module.exports = __webpack_public_path__ + "assets/img/syBorder.9c8b583a.png";